function customSlickSlider(opts) {
  const config = {
    dom: {
      sliderArrow: '.slick-arrow',
      slider: '.slick-slider',
      sliderContainer: 'slider-container',
      sliderTrack: '.slick-track',
      slides: '.slick-slide',
    },
    cls: {
      active: '.slick-active',
      cloned: '.slick-cloned',
      current: '.slick-current',
      disabled: '.slick-disabled',
      next: ['next', 'right'],
      prev: ['prev', 'left'],
    },
  };
  const c = $.extend(config, opts);
  const $sliders = document.querySelectorAll(c.dom.slider);

  function init() {
    if ($sliders?.length > 0) {
      $sliders.forEach(($slider) => {
        setInitialSlideVisibility($slider);
        addEvents($slider);
      });
    }
  }

  /**
   * Add events
   * @description Adds events
   * @param {HTMLElement} el - Slider element
   * @return {void}
   */
  function addEvents(el) {
    const $sliderParents = getParents(el);
    const $sliderParent = $sliderParents?.find(($parent) => $parent.classList.contains(c.dom.sliderContainer));
    if (!$sliderParent) return;

    const $slideButtons = Array.from($sliderParent?.querySelectorAll(c.dom.sliderArrow));

    [...$slideButtons].forEach(($button) => {
      $button.addEventListener('click', (e) => {
        const $parents = getParents(e.target);
        const $parent = $parents?.find(($parent) => $parent.classList.contains(c.dom.sliderContainer));
        const $currentSlider = $parent?.querySelector(c.dom.slider);

        if ($currentSlider) setSlideVisibility($currentSlider);
      });
    });
  }

  /** True when a single link inside the slide should be the only tab stop (e.g. .lob_cards > a). */
  function slideFocusOwnedByLink(slide) {
    const links = slide.querySelectorAll('a[href]');
    if (links.length !== 1) return false;
    if (slide.querySelector('button, input:not([type=hidden]):enabled, select, textarea')) return false;
    return links[0].getAttribute('tabindex') !== '-1';
  }

  /** aria/tabindex attrs for a focusable child inside a slick slide. */
  function getSlideFocusableAttrs(focusableEl) {
    if (focusableEl.getAttribute('tabindex') === '-1') return null;
    const attrs = { 'aria-hidden': 'false', tabindex: '0' };
    if (focusableEl.tagName === 'IMG') {
      if (focusableEl.closest('a')) delete attrs.tabindex;
      const alt = focusableEl.getAttribute('alt');
      if (alt === null || alt === '') return null;
    }
    return attrs;
  }

  /**
   * Set Initial Visibility
   * @description Sets the 'aria-hidden' state of slides as they come into the viewport
   * @param {HTMLElement} el - Slider element
   * @return {void}
   */
  function setInitialSlideVisibility(el) {
    const $slides = el.querySelectorAll(c.dom.slides);
    $slides.forEach((slide) => {
      // Only respect explicit tabindex="-1" from markup; plain divs report tabIndex -1 by default.
      if (slide.getAttribute('tabindex') === '-1') {
        return;
      }
      const linkOwned = slideFocusOwnedByLink(slide);
      setAttributes(slide, { 'aria-hidden': 'false' });
      if (linkOwned) slide.removeAttribute('tabindex');

      const focusableElements = slide.querySelectorAll('a, button, input, select, img');
      let hasTabTarget = false;
      focusableElements.forEach((focusableEl) => {
        const attrs = getSlideFocusableAttrs(focusableEl);
        if (attrs) {
          setAttributes(focusableEl, attrs);
          hasTabTarget = true;
        }
      });
      if (!linkOwned && !hasTabTarget) {
        setAttributes(slide, { tabindex: '0' });
      }
    });
  }

  /**
   * Set Visibility
   * @description Sets the 'aria-hidden' state of slides as they come into the viewport
   * @param {HTMLElement} el - Slider element
   * @return {void}
   */
  function setSlideVisibility(el) {
    const $slides = el.querySelectorAll(c.dom.slides);

    const targets = $slides;
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: .5
    };

    function callback(entries, observer) {
      entries.forEach(entry => {
        const slide = entry.target;

        if (slide.getAttribute('tabindex') === '-1') {
          observer.disconnect();
          return;
        }
        if (entry.isIntersecting) {
          const linkOwned = slideFocusOwnedByLink(slide);
          setAttributes(slide, { 'aria-hidden': 'false' });
          if (linkOwned) slide.removeAttribute('tabindex');

          const focusableElements = slide.querySelectorAll('a, button, input, select, img');
          let hasTabTarget = false;
          focusableElements.forEach((focusableEl) => {
            const attrs = getSlideFocusableAttrs(focusableEl);
            if (attrs) {
              setAttributes(focusableEl, attrs);
              hasTabTarget = true;
            }
          });
          if (!linkOwned && !hasTabTarget) {
            setAttributes(slide, { tabindex: '0' });
          }
          observer.disconnect();
        } else {
          const linkOwned = slideFocusOwnedByLink(slide);
          if (linkOwned) {
            setAttributes(slide, { 'aria-hidden': 'true' });
            slide.removeAttribute('tabindex');
          } else {
            setAttributes(slide, { 'aria-hidden': 'true', tabindex: '-1' });
          }
          const focusableElements = slide.querySelectorAll('a, button, input, select, img');
          if (focusableElements.length > 0) {
            focusableElements.forEach((focusableEl) => {
              setAttributes(focusableEl, { 'aria-hidden': 'true', tabindex: '-1' });
            });
          }
          observer.disconnect();
        }
      });
    }

    const observer = new IntersectionObserver(callback, options);
    [...targets].forEach(target => observer.observe(target));
  }

  return init();
}

customSlickSlider();
